// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"61":"browser-tip","594":"about"}[chunkId] + "." + {"61":"69577fcd","594":"dcecd9d7"}[chunkId] + ".css";
};